import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { useToast, Spinner } from '@chakra-ui/react';
import {
    getProjectCollaborators,
    inviteCollaborator,
    updateCollaboratorPermission,
    revokeCollaboratorAccess
} from '../../dashboardapi';
import styles from './ProjectModal.module.css';
import style from "./Sharedproject.module.css"

const ShareModal = ({ show, onClose, project }) => {
    const [collaborators, setCollaborators] = useState([]);
    const [email, setEmail] = useState("");
    const [permission, setPermission] = useState("read");
    const [loading, setLoading] = useState(false);
    const [inviteLoading, setInviteLoading] = useState(false);
    const toast = useToast();

    useEffect(() => {
        if (show && project) {
            fetchCollaborators();
        }
    }, [show, project]);

    const fetchCollaborators = async () => {
        setLoading(true);
        try {
            const result = await getProjectCollaborators(project.uuid);
            console.log("resultcolabratorsssss", result)
            if (result?.data || result?.data?.shares) {
                setCollaborators(result.data);
                console.log("colabratorsssss", collaborators)
            } else if (result.error) {
                console.error("Error fetching collaborators:", result.error);
                // Optional: show toast if needed, but might be annoying on load
            }
        } catch (error) {
            console.error("Error fetching collaborators:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleInvite = async (e) => {
        e.preventDefault();
        setInviteLoading(true);
        try {
            const result = await inviteCollaborator(project.uuid, email, permission);
            if (result.data) {
                toast({
                    title: "Invitation sent",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                setEmail("");
                fetchCollaborators(); // Refresh list
            } else if (result.error) {
                const errorMsg = result.error.detail || result.error.message || "Failed to invite user";
                toast({
                    title: "Failed to invite",
                    description: errorMsg,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error(error);
            toast({
                title: "Error inviting user",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setInviteLoading(false);
        }
    };

    const handlePermissionChange = async (shareId, newPermission) => {
        try {
            const result = await updateCollaboratorPermission(project.uuid, shareId, newPermission);
            if (result.data) {
                toast({
                    title: "Permission updated",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                fetchCollaborators();
            } else if (result.error) {
                toast({
                    title: "Error updating permission",
                    description: result.error.detail || "Unknown error",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error updating permission",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const handleRevoke = async (shareId) => {
        try {
            const result = await revokeCollaboratorAccess(project.uuid, shareId);
            if (result.data) {
                toast({
                    title: "Access revoked",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                fetchCollaborators();
            } else if (result.error) {
                toast({
                    title: "Error revoking access",
                    description: result.error.detail || "Unknown error",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error revoking access",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }

    return (

        <Modal show={show}>
            <div
                // className={styles.modalContainer}
                // style={{
                //     background: '#ffffff',
                //     borderRadius: '12px',
                //     boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                //     overflow: 'hidden',
                //     border: '1px solid #e2e8f0',
                //     minWidth: '620px',
                //     width: '100%',
                //     margin: '0 auto'
                // }}
                className={style.modalContainer}
            >
                {/* MODAL HEADER */}
                <div
                    // className={styles.modalheadingContainer}
                    // style={{
                    //     display: 'flex',
                    //     justifyContent: 'space-between',
                    //     alignItems: 'center',
                    //     padding: '18px 24px',
                    //     borderBottom: '1px solid #edf2f7',
                    //     background: '#f8fafc'
                    // }}
                    className={style.modalheadingContainer}
                >
                    <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        Share "{project?.name}"
                    </p>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#a0aec0',
                            padding: '6px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.background = '#edf2f7'; e.currentTarget.style.color = '#4a5568'; }}
                        onMouseOut={(e) => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#a0aec0'; }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                {/* MODAL BODY */}
                <div className={styles.modalContentContainer} style={{ padding: '24px' }}>
                    <div className={styles.formouter}>

                        {/* SECTION 1: INVITE USER */}
                        <div className={styles.inputdiv} style={{ display: 'flex', flexDirection: 'column' }}>
                            <label
                                //  style={{ fontSize: '14px', fontWeight: '600', color: '#2d3748', marginBottom: '4px' }}
                                className={styles.sharedModalHeadings}
                            >
                                Invite User
                            </label>
                            <label style={{ fontSize: '12px', color: '#718096', marginBottom: '12px', lineHeight: '1.4' }}>
                                Enter the email address of the user you want to share this project with.
                            </label>

                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <input
                                    type="email"
                                    placeholder="Enter email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    // style={{
                                    //     flex: 1,
                                    //     height: '40px',
                                    //     padding: '0 14px',
                                    //     borderRadius: '6px',
                                    //     border: '1px solid #cbd5e0',
                                    //     fontSize: '14px',
                                    //     color: '#2d3748',
                                    //     outline: 'none',
                                    //     transition: 'border-color 0.2s'
                                    // }}
                                    className={style.shareInput}
                                    onFocus={(e) => e.currentTarget.style.borderColor = '#3182ce'}
                                    onBlur={(e) => e.currentTarget.style.borderColor = '#cbd5e0'}
                                />
                                <select
                                    value={permission}
                                    onChange={(e) => setPermission(e.target.value)}
                                    style={{
                                        width: '100px',
                                    }}
                                    className={style.shareSelectOption}
                                >
                                    <option value="read">Read</option>
                                    <option value="write">Write</option>
                                </select>
                                <button
                                    className={`${styles.btn2} ${!email || inviteLoading ? styles.emptyemail : styles.invite
                                        }`}
                                    onClick={handleInvite}
                                    disabled={!email || inviteLoading}
                                    style={{
                                        height: '40px',
                                        padding: '0 20px',
                                        // background: !email || inviteLoading ? `${styles.emptyemail}` : `${styles.invite}`,
                                        color: !email || inviteLoading ? '#a0aec0' : '#ffffff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        cursor: !email || inviteLoading ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'background 0.2s'
                                    }}
                                // onMouseOver={(e) => { if (!email && !inviteLoading) e.currentTarget.style.background = '#2b6cb0' }}
                                // onMouseOut={(e) => { if (!email && !inviteLoading) e.currentTarget.style.background = '#3182ce' }}
                                >
                                    {inviteLoading ? <Spinner size="sm" /> : "Invite"}
                                </button>
                            </div>
                        </div>

                        {/* SECTION 2: COLLABORATORS LIST */}
                        <div className={styles.inputdiv} style={{ marginTop: '28px', display: 'flex', flexDirection: 'column' }}>
                            <label
                                // style={{ fontSize: '14px', fontWeight: '600', color: '#2d3748', marginBottom: '10px' }}
                                className={style.sharedModalHeadings}
                            >
                                Collaborators
                            </label>

                            <div
                                // style={{
                                //     maxHeight: '220px',
                                //     overflowY: 'auto',
                                //     border: '1px solid #e2e8f0',
                                //     borderRadius: '8px',
                                //     background: '#f8fafc',
                                //     padding: '6px'
                                // }}
                                className={style.collaborators}
                            >
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '30px' }}>
                                        <Spinner />
                                    </div>
                                ) : collaborators.length === 0 ? (
                                    <div style={{ padding: '32px 16px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5" style={{ marginBottom: '8px' }} xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <p style={{ color: '#718096', fontSize: '14px', margin: 0 }}>No collaborators yet.</p>
                                    </div>
                                ) : (
                                    collaborators.map((collab) => (
                                        <div
                                            key={collab.id}
                                            // style={{
                                            //     display: 'flex',
                                            //     justifyContent: 'space-between',
                                            //     alignItems: 'center',
                                            //     padding: '10px 12px',
                                            //     marginBottom: '6px',
                                            //     background: '#ffffff',
                                            //     borderRadius: '6px',
                                            //     border: '1px solid #edf2f7',
                                            //     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)'
                                            // }}
                                            className={style.collaboratorsList}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                <span style={{ fontWeight: '500', fontSize: '14px' }}>
                                                    {collab.recipient_email}
                                                </span>
                                                {collab.status && collab.status !== 'active' && (
                                                    <span style={{
                                                        fontSize: '11px',
                                                        fontWeight: '500',
                                                        color: collab.status === 'pending' ? '#dd6b20' : '#2e850f',
                                                        textTransform: 'capitalize'
                                                    }}>
                                                        • {collab.status === 'pending' ? 'Pending Invite' : collab.status}
                                                    </span>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                <select
                                                    value={collab.permission}
                                                    onChange={(e) => handlePermissionChange(collab.id, e.target.value)}
                                                    disabled={collab.status === 'pending' || collab.status === 'declined'}
                                                    // style={{
                                                    //     height: '40px',
                                                    //     padding: '0 15px',
                                                    //     borderRadius: '4px',
                                                    //     border: '1px solid #cbd5e0',
                                                    //     fontSize: '13px',
                                                    //     color: 'var(--bg)',
                                                    //     background: collab.status === 'pending' || collab.status === 'declined' ? '#edf2f7' : '#fff',
                                                    //     cursor: collab.status === 'pending' || collab.status === 'declined' ? 'not-allowed' : 'pointer',
                                                    //     outline: 'none'
                                                    // }}
                                                    // className={style.sharebgcolor}
                                                    className={`${style.shareSelect} ${(collab.status === 'pending' || collab.status === 'declined')
                                                            ? style.shareSelectDisabled
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="read">Read</option>
                                                    <option value="write">Write</option>
                                                </select>
                                                <button
                                                    onClick={() => handleRevoke(collab.id)}
                                                    style={{
                                                        color: '#e53e3e',
                                                        background: 'none',
                                                        border: '1px solid #fed7d7',
                                                        borderRadius: '4px',
                                                        padding: '4px 10px',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    onMouseOver={(e) => { e.currentTarget.style.background = '#fff5f5'; e.currentTarget.style.borderColor = '#e53e3e'; }}
                                                    onMouseOut={(e) => { e.currentTarget.style.background = 'none'; e.currentTarget.style.borderColor = '#fed7d7'; }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ShareModal;
